import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Laborator from "./Laborator";
import Packages from "./Packages";
import Specialties from "./Specialties";
import WhyMedas from "./WhyMedas";
import Doctors from "./Doctors";
import Gallery from "./Gallery";
import Testimonials from "./Testimonials";
import Location from "./Location";
import Contact from "./Contact";

function useTitle(title, description) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    return () => { document.title = "MEDAS Timișoara | Laborator Analize Medicale & Clinică"; };
  }, [title, description]);
}

function PageHeader({ title, subtitle, crumb }) {
  return (
    <section className="pt-28 lg:pt-36 pb-10 champagne-gradient">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-2 text-sm text-[#8A7A5E] mb-4">
          <Link to="/" className="hover:text-[#A6823B]">Acasă</Link>
          <ChevronRight className="w-4 h-4" />
          <span className="text-[#4A3F2E] font-medium">{crumb}</span>
        </div>
        <h1 className="font-display text-3xl lg:text-5xl font-extrabold text-[#2A2521]" data-testid="page-title">{title}</h1>
        {subtitle && <p className="mt-3 text-lg text-[#6B5C43] max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}

export function LaboratorPage() {
  useTitle("Laborator Analize Medicale Timișoara | Prețuri | MEDAS",
    "Catalog complet de analize medicale cu prețuri la MEDAS Timișoara. Peste 250 de analize, laborator acreditat RENAR. Programează-te: 0711 981 550.");
  return (<><PageHeader crumb="Laborator Analize" title="Laborator de analize medicale" subtitle="Catalog transparent cu prețuri, într-un laborator propriu acreditat RENAR." /><Laborator /><Gallery filter="laborator" eyebrow="Galerie laborator" title="Spațiile laboratorului nostru" subtitle="Camere de recoltare rafinate și o zonă de lucru dotată la cele mai înalte standarde." bg="bg-[#FBF7EF]" /></>);
}

export function PachetePage() {
  useTitle("Pachete Analize Medicale Timișoara | Prețuri | MEDAS",
    "Pachete de analize medicale la prețuri avantajoase la MEDAS Timișoara: check-up general, pachet femei, pachet bărbați, screening tiroidian.");
  return (<><PageHeader crumb="Pachete" title="Pachete de analize" subtitle="Selecții atent alcătuite, la un preț pe măsura grijii pentru sănătatea ta." /><Packages /></>);
}

export function SpecialitatiListPage() {
  useTitle("Specialități Medicale Timișoara | MEDAS",
    "Peste 12 specialități medicale la MEDAS Timișoara: laborator, ginecologie, medicină de familie, endocrinologie, pediatrie și stomatologie.");
  return (<><PageHeader crumb="Specialități" title="Specialități medicale" subtitle="Alege o specialitate și descoperă o îngrijire gândită până la ultimul detaliu." /><Specialties /></>);
}

export function RecenziiPage() {
  useTitle("Recenzii Pacienți | MEDAS Timișoara",
    "Peste 50.000 de pacienți ne acordă încrederea. Citește recenziile reale ale pacienților clinicii MEDAS Timișoara.");
  return (<><PageHeader crumb="Recenzii" title="Ce spun pacienții noștri" subtitle="Povești reale ale celor care ne-au acordat încrederea." /><Testimonials /></>);
}

export function DesprePage() {
  useTitle("Despre Noi | MEDAS Timișoara – Clinică & Laborator din 2007",
    "Află povestea MEDAS Timișoara: clinică și laborator acreditat RENAR, din 2007, cu echipă medicală experimentată și îngrijire premium.");
  return (<><PageHeader crumb="Despre Noi" title="Despre MEDAS" subtitle="Clinică medicală și laborator de excepție, cu o poveste ce începe în 2007." /><WhyMedas /><Doctors /><Gallery /></>);
}

export function ContactPage() {
  useTitle("Contact & Programări | MEDAS Timișoara",
    "Contactează MEDAS Timișoara. Str. Letea 25. Programează-te telefonic la 0711 981 550. Program Luni–Vineri 07:00–20:00.");
  return (<><PageHeader crumb="Contact" title="Contact & Programări" subtitle="Programează-te printr-un simplu telefon — de restul ne ocupăm noi." /><Contact /><Location /></>);
}
